/* eslint camelcase: 0 */

import { useEffect, useRef } from "react";
import { POST_EMBED_TOKEN } from "../../../api/integrations/zapier";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

// Survive Strict Mode remount: prevent double request and double success toast
let zapierEmbedJustSaved = false;
let zapierEmbedHandlingInProgress = false;
let zapierEmbedSuccessToastShown = false;

const Authentication = () => {
  const navigate = useNavigate();
  const hasHandledRef = useRef(false);

  useEffect(() => {
    if (hasHandledRef.current || zapierEmbedHandlingInProgress) return;

    const hashPart = window.location.hash ? window.location.hash.split("#")[1] : "";
    const params = Object.fromEntries(new URLSearchParams(hashPart || ""));
    const { access_token, token_type, refresh_token, expires_in } = params;

    if (access_token && token_type) {
      hasHandledRef.current = true;
      zapierEmbedHandlingInProgress = true;
      POST_EMBED_TOKEN({
        access_token,
        token_type,
        ...(refresh_token && { refresh_token }),
        ...(expires_in != null && { expires_in: Number(expires_in) }),
      })
        .then(() => {
          zapierEmbedHandlingInProgress = false;
          zapierEmbedJustSaved = true;
          if (zapierEmbedSuccessToastShown) return;
          zapierEmbedSuccessToastShown = true;
          toast.success("Zapier access credentials saved.");
          navigate("/workspace-kpi/custom-metric-types");
        })
        .catch(() => {
          zapierEmbedHandlingInProgress = false;
          hasHandledRef.current = false;
          toast.error("Failed to save Zapier access credentials.");
        });
    } else {
      if (zapierEmbedJustSaved) {
        zapierEmbedJustSaved = false;
        zapierEmbedSuccessToastShown = false;
        navigate("/workspace-kpi/custom-metric-types");
        return;
      }
      hasHandledRef.current = true;
      toast.error("Zapier access credentials not found.");
    }
  }, [navigate]);

  return null;
};

export default Authentication;
